import { Box, Paper } from "@mui/material";
import ionis_logo from "../images/ionis_logo.png";

// Carte centrée partagée par les écrans d'authentification (connexion,
// première connexion, initialisation de compte, mot de passe).
function AuthCard({ children, maxWidth = 440 }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "auto", sm: "70vh" },
        px: 2,
      }}
    >
      <Paper elevation={3} sx={{ width: "100%", maxWidth, p: { xs: 3, sm: 4 } }}>
        <Box
          component="img"
          src={ionis_logo}
          alt="IONIS"
          sx={{ height: 40, display: "block", mx: "auto", mb: 3 }}
        />
        {children}
      </Paper>
    </Box>
  );
}

export default AuthCard;
